export default __webpack_public_path__ + "static/media/servicebreak.3d783c84.png";